import React from 'react'

const Grid = props => {
  const items = []
  for (let i = 0; i < props.items.length; ++i) {
    let item = props.items[i]
    item.key = i
    item.idx = i + 1 // quick hack to label index, the key property is hidden in react elements
    items.push(React.createElement(props.template, item, null))
  }
  return <>{items}</>
}

export default Grid
